import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

interface CustomerInfo {
  first_name: string;
  last_name: string;
  email: string;
  number: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
  allowSMS?: boolean;
}

interface PurchaseInfo {
  store_purchase: string;
  retailer_phone: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
  purchase_date: string;
  invoice_image: string;
}

interface DamageInfo {
  date_incident: string;
  product_type: string;
  product_size: string;
  mattress_stained_damaged: string;
  type_of_stain_damage: string;
  protector_damage: string;
  damageNotes: string;
  damage_Protector_type: string;
  estimated_retail_value: number;
  did_clean_product: string;
  protector_on_bed: string;
}

interface Documents {
  protector_damage_images: string[];
  mattress_damage_images: string[];
  protectall_tag_image: string;
}

export interface ClaimState {
  id: string; // temp id for store documnets in S3
  name: string;
  customerInfo: CustomerInfo;
  purchaseInfo: PurchaseInfo;
  damageInfo: DamageInfo;
  documents: Documents;
}

export enum ClaimAction {
  UPSERT_CLAIM = "UPSERT_CLAIM",
  REMOVE_CLAIM_IMAGE = "REMOVE_CLAIM_IMAGE",
  UPLOAD_CLAIM_IMAGE = "UPLOAD_CLAIM_IMAGE",
  SUBMIT_CLAIM = "SUBMIT_CLAIM",
  UPDTAE_CLAIM_STATE = "UPDTAE_CLAIM_STATE",
  CLEAN_UP = "CLEAN_UP",
}

export type ClaimActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export const ClaimScope = "claim";
